export default "__VITE_ASSET__ce00de43__"